module.exports = __webpack_public_path__ + "static/media/DSC_0885.ae59229c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0885.jpg
// module id = 706
// module chunks = 0